import * as React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import introspectionQueryResultData from 'src/graphql/fragmentTypes.json';
import { createCache, createClient } from 'src/services/Graph';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

export const GraphProvider = ({ children }: { children: React.ReactElement }) => (
  <ApolloProvider client={createClient(createCache({ fragmentMatcher }))}>
    {children}
  </ApolloProvider>
);
